import axios from "axios";
import * as actionTypes from "./constants";
import { setSuccessMessage } from "../../messages/actions";
export const getRoomGroups = () => {
  return (dispatch, getState) => {
    const hotelId = getState().hotels.selected;
    dispatch({ type: actionTypes.GET_ROOM_GROUPS_REQUEST });
    return axios
      .get("/roomgroups/" + hotelId)
      .then(response => {
        dispatch({
          type: actionTypes.GET_ROOM_GROUPS_SUCCESS,
          roomGroups: response.data
        });
      })
      .catch(err => {
        dispatch({ type: actionTypes.GET_ROOM_GROUPS_REJECT, err });
      });
  };
};

export const addRoomGroup = roomGroup => {
  return (dispatch, getState) => {
    const hotelId = getState().hotels.selected;
    dispatch({ type: actionTypes.ADD_ROOM_GROUP_REQUEST });
    return axios
      .post("/roomgroups", {
        ...roomGroup,
        hotelId
      })
      .then(response => {
        dispatch({
          type: actionTypes.ADD_ROOM_GROUP_SUCCESS,
          roomGroup: response.data
        });
        dispatch(setSuccessMessage("room:addedRoomTypeText"));
      })
      .catch(err => {
        dispatch({ type: actionTypes.ADD_ROOM_GROUP_REJECT, err });
      });
  };
};

export const editRoomGroup = roomGroup => {
  return dispatch => {
    dispatch({
      type: actionTypes.EDIT_ROOM_GROUP_REQUEST
    });
    return axios
      .put(`/roomgroups/${roomGroup.roomGroupId}`, roomGroup)
      .then(() =>
        dispatch({
          type: actionTypes.EDIT_ROOM_GROUP_SUCCESS,
          roomGroup
        })
      )
      .catch(err =>
        dispatch({
          type: actionTypes.EDIT_ROOM_GROUP_REJECT,
          err
        })
      );
  };
};

export const removeRoomGroup = roomGroupId => {
  return dispatch => {
    dispatch({ type: actionTypes.REMOVE_ROOM_GROUP_REQUEST });
    return axios
      .delete("/roomgroups/" + roomGroupId)
      .then(response => {
        dispatch({
          type: actionTypes.REMOVE_ROOM_GROUP_SUCCESS,
          roomGroupId
        });
        dispatch(setSuccessMessage("room:removedRoomTypeText"));
      })
      .catch(err => {
        dispatch({ type: actionTypes.REMOVE_ROOM_GROUP_REJECT, err });
      });
  };
};



// WEBPACK FOOTER //
// ./src/rooms/groups/actions.js